import { render, staticRenderFns } from "./Km-Support-Dashboard.vue?vue&type=template&id=523291cd&scoped=true&"
import script from "./Km-Support-Dashboard.vue?vue&type=script&lang=js&"
export * from "./Km-Support-Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Km-Support-Dashboard.vue?vue&type=style&index=0&id=523291cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523291cd",
  null
  
)

export default component.exports